module.exports = __webpack_public_path__ + "static/img/minip1.94eddbfc.png";